import React, { useEffect, useState } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import DataTable from "react-data-table-component";

//Redux
import { useSelector } from "react-redux"; //useDispatch

//Serivce

//Components
import Layout from "../../../../Layout/Layout";
import CustomerConstants from "../../../../common/CustomerConstants";
// import { InputField } from "../../../Components/formElements/InputField";
import { ComboboxField } from "../../../../Components/formElements/ComboboxField";
import { SearchField } from "../../../../Components/formElements/SearchField";
// import CatalogListEditModal from "../../../../Components/Modal/customer_app/CatalogModal/CatalogListEditModal";
// import CatalogListAddProductModal from "../../../../Components/Modal/customer_app/CatalogModal/CatalogListAddProductModal";
// import CatalogProductDetailModal from "../../../../Components/Modal/customer_app/CatalogModal/CatalogProductDetailModal";
import EquipmentModal from "./EquipmentModal";
import EquipmentModalCopy from "./EquipmentModalCopy";
import RentCancelModal from "./RentCancelModal";
// import EquipmentListEditModal from "./RequestRentListEditModal";
import RequestRentListEditModal from "./RequestRentListEditModal";
import RequestForRentDetails from "./RequestForRentDetails";

const RequestForRentList = () => {
  localStorage.setItem("menu", "Rent");
  localStorage.setItem("submenu", "Rent List");

  //   let userData = useSelector((state) => state?.user); // User Details from Store
  // let purchaseOrderData = useSelector(
  //   (state) => state?.purchasing?.purchase_order
  // );
  let purchaseOrderTable = useSelector(
    (state) => state?.purchasing?.purchase_order?.pagination
  );

  const [isCardVisible1, setCardVisible1] = useState(true);
  const [isCardVisible2, setCardVisible2] = useState(true);

  const toggleCardVisibility1 = () => {
    setCardVisible1(!isCardVisible1);
  };
  const toggleCardVisibility2 = () => {
    setCardVisible2(!isCardVisible2);
  };
  let CategorydropdownOptions = [
    {
      id: "1",
      name: "Oxygen Concentrators ",
    },
    {
      id: "2",
      name: "Ventilators",
    },
    {
      id: "3",
      name: "Walking Sticks ",
    },
    {
      id: "4",
      name: "Crutches ",
    },
    {
      id: "5",
      name: "Posture Support ",
    },
  ];
  let Subcategory = [
    {
      id: "1",
      subCategory: "Oxygen Concentrators",
      name: "Oxygen Concentrators",
    },
    {
      id: "2",
      subCategory: "Ventilators",
      name: "Ventilators",
    },
    {
      id: "3",
      subCategory: "Walking Sticks",
      name: "Walking Sticks",
    },
    {
      id: "4",
      subCategory: "Crutches",
      name: "Crutches",
    },
    {
      id: "5",
      subCategory: "Posture Support",
      name: "Posture Support",
    },
  ];

  // let StatusdropdownOptions = [
  //   {
  //     id: "1",
  //     name: "All status",
  //   },
  //   {
  //     id: "2",
  //     name: "single status",
  //   },
  //   {
  //     id: "3",
  //     name: "double status",
  //   },
  // ];
  let pricedropdownOptions = [
    {
      id: "1",
      name: "1000-2000",
    },
    {
      id: "2",
      name: "2000-3000",
    },
    {
      id: "3",
      name: "4000-8000",
    },
  ];
  // let StoredropdownOptions = [
  //   {
  //     id: "1",
  //     name: "All store",
  //   },
  //   {
  //     id: "2",
  //     name: "Adiddas",
  //   },
  //   {
  //     id: "3",
  //     name: "Alian soly",
  //   },
  // ];
  // let LineItemStatusdropdownOptions = [
  //   {
  //     id: "1",
  //     name: "Active",
  //   },
  //   {
  //     id: "2",
  //     name: "Pending",
  //   },
  //   {
  //     id: "3",
  //     name: "Sold Out",
  //   },
  // ];

  const data = [
    {
      id: 11,
      productName: "Oxymed 10 Liter Oxygen Concentrator",
      productNumber: "OXM10001",
      category: "Medical Equipment",
      subCategory: "Oxygen Concentrators",
      gmdnCode: "35362",
      hsnCode: "9019",
      stock: 25,
      rentPerDay: 2000,
      sold: 18,
      views: 1200,
      totalRent: 360000,
      price: 85000,
      discount: 10,
      discountedPrice: 76500,
      description:
        "High-flow 10L oxygen concentrator ideal for long-term oxygen therapy.",
      vendor: "Oxymed",
      vendorLocation: "Delhi, India",
      rating: 4.7,
      reviews: 48,
      weight: "27kg",
      dimensions: "68cm x 37cm x 39cm",
      color: "White",
      material: "ABS Plastic",
      careInstructions: "Keep in ventilated space, clean filters regularly",
      availability: "In Stock",
      imageUrl: "assets/img/product_img/M1.jpg",
      createdAt: "2024-06-01",
      updatedAt: "2024-06-15",
      tags: ["oxygen", "therapy", "concentrator"],
      warranty: "2 years",
      returnPolicy: "Return within 15 days",
      shipping: {
        availableRegions: ["India", "UAE", "Europe"],
        estimatedDelivery: "3-7 business days",
        cost: "Free",
      },
      days: "10",
      companyName: "Sukino (Continuum Care Facility",
      deliveryAddress:
        "Koramangala – 426, 8th Main Rd, 4-B Block, Bengaluru 560034 · Ph: 76762 99000",
      vendorPhone: "+91-9876543210",
      vendorEmail: "support@oxymed.in",
      serviceDate: "2025-06-15",
      serviceCompanyName: "Oxymed Service Pvt Ltd",
      serviceWarranty: "2 years",
      serviceType: "Annual Maintenance",
      serviceEngineer: "Rajesh Kumar",
      status: "Active",
      notes: "Next service due in June 2026",
      featured: true,
      seasonal: false,
      bestseller: true,
    },
    {
      id: 12,
      productName: "ResMed Astral 150 Ventilator APAC2",
      productNumber: "RMD15002",
      category: "Medical Equipment",
      subCategory: "Ventilators",
      gmdnCode: "41333",
      hsnCode: "9019",
      stock: 10,
      rentPerDay: 3000,
      sold: 5,
      views: 950,
      totalRent: 15000,
      price: 620000,
      discount: 8,
      discountedPrice: 570400,
      description:
        "Portable life support ventilator designed for both invasive and non-invasive care.",
      vendor: "ResMed",
      vendorLocation: "Sydney, Australia",
      rating: 4.9,
      reviews: 20,
      weight: "3.2kg",
      dimensions: "28cm x 21cm x 9cm",
      color: "Silver",
      material: "High-grade polymer",
      careInstructions: "Use with care, follow service intervals",
      availability: "In Stock",
      imageUrl: "assets/img/product_img/M2.jpg",
      createdAt: "2024-06-05",
      updatedAt: "2024-06-18",
      tags: ["ventilator", "portable", "life support"],
      warranty: "3 years",
      returnPolicy: "Return within 7 days",
      shipping: {
        availableRegions: ["India", "USA", "Europe"],
        estimatedDelivery: "4-8 business days",
        cost: "Paid",
      },
      days: "1",
      // vendor: "ResMed",
      //  vendorLocation: "Sydney, Australia",
      vendorEmail: "contact@resmed.com.au",
      vendorPhone: "+61-412345678",
      serviceDate: "2025-06-20",
      serviceCompanyName: "ResMed Support Intl",
      serviceWarranty: "3 years",
      serviceType: "Bi-annual Service",
      serviceEngineer: "Emily Watson",
      status: "Active",
      notes: "Calibration needed every 6 months",
      companyName: "KITES Senior Care",
      deliveryAddress:
        "70, 2nd Main Rd, Bharathi Layout, Balaji Nagar, S.G. Palya, Bengaluru – 560029",
      featured: true,
      seasonal: false,
      bestseller: false,
    },
    {
      id: 13,
      productName: "Monopad Walking Stick With Seat",
      productNumber: "MONO3001",
      category: "Mobility Assistance In Daily Steps",
      subCategory: "Walking Sticks",
      gmdnCode: "42211506",
      hsnCode: "9021",
      stock: 60,
      rentPerDay: 800,
      totalRent: 64000,
      sold: 10,
      views: 2300,
      price: 2200,
      discount: 5,
      discountedPrice: 2090,
      description:
        "Lightweight walking stick with an integrated foldable seat.",
      vendor: "Monopad",
      vendorLocation: "Mumbai, India",
      rating: 4.4,
      reviews: 25,
      weight: "1.2kg",
      dimensions: "80cm x 30cm x 10cm",
      color: "Black",
      material: "Aluminum",
      careInstructions: "Wipe clean with dry cloth",
      availability: "In Stock",
      imageUrl: "assets/img/product_img/M3.jpg",
      createdAt: "2024-05-15",
      updatedAt: "2024-06-01",
      tags: ["mobility", "stick", "seat"],
      warranty: "1 year",
      returnPolicy: "Return within 10 days",
      shipping: {
        availableRegions: ["India", "UK", "USA"],
        estimatedDelivery: "5-7 business days",
        cost: "Free",
      },
      days: "8",
      vendorEmail: "info@monopad.com",
      vendorPhone: "+91-9988776655",
      serviceDate: "2025-05-10",
      serviceCompanyName: "Monopad Mobility Services",
      serviceWarranty: "1 year",
      serviceType: "Inspection",
      serviceEngineer: "Karan Desai",
      status: "Active",
      notes: "Low wear and tear observed",
      companyName: "KITES Senior Care",
      deliveryAddress:
        "70, 2nd Main Rd, Bharathi Layout, Balaji Nagar, S.G. Palya, Bengaluru – 560029",
      featured: false,
      seasonal: false,
      bestseller: false,
    },
    {
      id: 14,
      productName: "Rebotec Elbow Crutch Child - Yellow",
      productNumber: "RBT2001",
      category: "Mobility Assistance In Daily Steps",
      subCategory: "Crutches",
      gmdnCode: "36082",
      hsnCode: "9021",
      stock: 30,
      rentPerDay: 500,
      totalRent: 40000,
      sold: 20,
      views: 1800,
      price: 3500,
      discount: 10,
      discountedPrice: 3150,
      description: "Colorful and ergonomic elbow crutch designed for children.",
      vendor: "Rebotec",
      vendorLocation: "Germany",
      rating: 4.6,
      reviews: 32,
      weight: "800g",
      dimensions: "70cm x 18cm x 5cm",
      color: "Yellow",
      material: "Plastic and aluminum",
      careInstructions: "Clean with mild soap and water",
      availability: "In Stock",
      imageUrl: "assets/img/product_img/M4.jpg",
      createdAt: "2024-04-20",
      updatedAt: "2024-05-10",
      tags: ["crutch", "children", "mobility"],
      warranty: "1 year",
      returnPolicy: "Return within 15 days",
      shipping: {
        availableRegions: ["Europe", "India", "Australia"],
        estimatedDelivery: "4-6 business days",
        cost: "Free",
      },
      days: "4",
      vendorEmail: "help@rebotec.de",
      vendorPhone: "+49-123456789",
      serviceDate: "2025-04-05",
      serviceCompanyName: "Rebotec TechCare",
      serviceWarranty: "1 year",
      serviceType: "General Checkup",
      serviceEngineer: "Lukas Schmidt",
      status: "Active",
      notes: "No issues found during last service",
      companyName: "KITES Senior Care",
      deliveryAddress:
        "70, 2nd Main Rd, Bharathi Layout, Balaji Nagar, S.G. Palya, Bengaluru – 560029",
      featured: true,
      seasonal: false,
      bestseller: false,
    },
    {
      id: 15,
      productName: "Amron Xamax Backrest",
      productNumber: "AMX9001",
      category: "Wellness",
      subCategory: "Posture Support",
      gmdnCode: "N/A",
      hsnCode: "9021",
      stock: 100,
      rentPerDay: 2000,
      totalRent: 180000,
      sold: 15,
      views: 2700,
      price: 2900,
      discount: 15,
      discountedPrice: 2465,
      description:
        "Orthopedic backrest for spine support during long sitting hours.",
      vendor: "Amron Xamax",
      vendorLocation: "Bangalore, India",
      rating: 4.5,
      reviews: 55,
      weight: "1kg",
      dimensions: "45cm x 40cm x 10cm",
      color: "Grey",
      material: "High-density foam and mesh",
      careInstructions: "Spot clean only",
      availability: "In Stock",
      imageUrl: "assets/img/product_img/M5.gif",
      createdAt: "2024-03-30",
      updatedAt: "2024-04-10",
      tags: ["backrest", "posture", "orthopedic"],
      warranty: "6 months",
      returnPolicy: "Return within 15 days",
      shipping: {
        availableRegions: ["India", "UAE", "UK"],
        estimatedDelivery: "3-6 business days",
        cost: "Free",
      },
      days: "6",
      vendorEmail: "care@amronxamax.com",
      vendorPhone: "+91-9123456780",
      serviceDate: "2025-03-12",
      serviceCompanyName: "Xamax Care Services",
      serviceWarranty: "6 months",
      serviceType: "Post-sale Support",
      serviceEngineer: "Sneha Rao",
      status: "Active",
      notes: "Customer satisfied with support",
      companyName: "Prakruti Home Health Care",
      deliveryAddress:
        "#121, 4th Main, JP Nagar 7th Phase, near Indian Oil Petrol Bunk, Puttenahalli, Bengaluru – 560078",
      featured: false,
      seasonal: false,
      bestseller: true,
    },
  ];

  const [modalShowEditProduct, setModalShowEditProduct] = useState(false);
  const [modalShowAddProduct, setModalShowAddProduct] = useState(false);
  const [modalShowForRent23, setModalShowForRent23] = useState(false);
  const [modalShowDetailProduct, setModalShowDetailProduct] = useState(false);

  const [equipmentData, setEquipmentData] = useState(null);
  const [editEquipmentData, setEditEquipmentData] = useState(null);

  const showEditProduct = (data) => {
    setModalShowEditProduct(true);
    setEditEquipmentData(data);
  };
  // const showAddProduct = () => {
  //   setModalShowAddProduct(true);
  // };
  const requestForRent = () => {
    setModalShowForRent23(true);
  };
  // const showProductDetail = (e) => {
  //   setModalShowDetailProduct(true);
  //   console.log("product detail clicked", e)
  // };
  const hideModal = () => {
    setModalShowEditProduct(false);
    setModalShowAddProduct(false);
    setModalShowDetailProduct(false);
    setModalShowForRent23(false);
  };

  const [getCancelModalStatus, setCancelModalStatus] = useState(false);
  const cancelModalShow = () => {
    setCancelModalStatus(true);
  };
  const cancelModalHide = () => {
    setCancelModalStatus(false);
  };

  const columns = [
    {
      name: "EquipMent Name",
      selector: (row) => row.productName || "--",
      cell: (row) => (
        <div
          className="d-flex justify-content-center align-items-center cursor-pointer"
          onClick={() => equipmentDetails(row)}
        >
          <img
            src={row.imageUrl}
            alt="Profile"
            className="profileImageCss p-1"
            style={{ width: "60px" }}
          />
          <div className="ms-2">
            <p className="m-0 p-0 pt-1 fw-bold">{row.productName} </p>
            <p className="m-0 p-0 pt-1">{row.productNumber} </p>
          </div>
        </div>
      ),
      sortable: true,
      width: "400px",
    },
    {
      name: "Company Name",
      selector: (row) => row.companyName || "--",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1">{row.companyName} </p>
        </div>
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "Delivery Address",
      selector: (row) => row.deliveryAddress || "--",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1">{row.deliveryAddress} </p>
        </div>
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "Category/SubCategory",
      selector: (row) => row.category || "--",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1">
            {row.category ? row.category : "No Category"}
          </p>
          <p className="m-0 p-0 pt-1">
            {row.subCategory ? row.subCategory : "No SubCategory"}
          </p>
        </div>
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "Equipment Code",
      selector: (row) => row.category || "--",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1">{row.productNumber} </p>
        </div>
      ),
      // sortable: true,
      width: "140px",
    },
    {
      name: "Rent Days",
      selector: (row) => row.days || "--",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1">{row.days} </p>
        </div>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Rent For oneDay",
      selector: (row) => row.rentPerDay || "--",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1">{row.rentPerDay} </p>
        </div>
      ),
      // sortable: true,
      width: "140px",
    },
    {
      name: "Rented",
      selector: (row) => row.sold || "--",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1">{row.sold} </p>
        </div>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Total Rent",
      selector: (row) => row.totalRent || "--",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1">{row.totalRent} </p>
        </div>
      ),
      sortable: true,
      width: "140px",
    },
    // {
    //   name: "Status",
    //   selector: (row) => row.purchaseType || "--",
    //   cell: (row) => (
    //     <div>
    //       <ComboboxField
    //         label=""
    //         placeholder="Please select the status"
    //         data={LineItemStatusdropdownOptions}
    //         id="category"
    //         iconClassName="dropdownIcon"
    //         // className="z-9"
    //         name="category"
    //         code="categorycode"
    //         description="countryDesc"
    //       //   setValue={formInputs.country}
    //       // getvalue={setDropdownData}
    //       />
    //     </div>
    //   ),
    //   sortable: true,
    //   width: "200px",
    // },
    {
      name: "Action",
      selector: (row) => row.purchaseType || "--",
      cell: (row) => (
        <div>
          <button
            className="btn d-flex align-items-center w-100"
            onClick={() => showEditProduct(row)}
          >
            <i class="bi bi-pencil-square pe-2"></i>{" "}
            <sapn className="m-0 p-0 pt-1">Edit </sapn>
          </button>
        </div>
      ),
      sortable: true,
      width: "120px",
    },
    {
      name: "Delete",
      selector: (row) => row.purchaseType || "--",
      cell: (row) => (
        <div>
          <button class="btn btn-danger">
            <i class="bi bi-trash3"></i>
          </button>
        </div>
      ),
      sortable: true,
      width: "200px",
    },
  ];
  /* Handle selected rows */
  const [getSelectedRows, setSelectedRows] = useState([]);
  console.log("getSelectedRows", getSelectedRows);
  const handleRowSelected = ({ selectedRows }) => {
    // const validRows = selectedRows.filter(
    //   (item) => item?.invoiceStatusHeader !== "Cancelled"
    // );
    setSelectedRows(selectedRows);
  };
  const [selectedCategory, setSelectedCategory] = useState({}); // dropdown selection
  const [filteredProducts, setFilteredProducts] = useState([]);

  const [getDropdownData, setDropdownData] = useState("");

  useEffect(() => {
    if (getDropdownData?.textField) {
      setSelectedCategory((prev) => ({
        ...prev,
        [getDropdownData.textField]: getDropdownData.name,
      }));
    }
  }, [getDropdownData]);

  const handleSearchClick = () => {
    const selectedSubCategory = selectedCategory?.category
      ?.trim()
      .toLowerCase();
    // const selectedPrice = selectedCategory?.price?.trim();

    let filtered = data;

    if (selectedSubCategory) {
      filtered = filtered.filter(
        (item) => item.subCategory?.trim().toLowerCase() === selectedSubCategory
      );
    }

    // if (selectedPrice) {
    //   filtered = filtered.filter(
    //     (item) => String(item.price)?.trim() === selectedPrice
    //   );
    // }

    setFilteredProducts(filtered);
  };

  const handleRefresh = () => {
    setSelectedCategory({
      category: "",
      price: "",
      sortBy: "",
      subCategory: "",
    });
    setDropdownData({});
    setFilteredProducts(data);
  };

  const equipmentDetails = (data) => {
    setEquipmentData(data);
    setModalShowDetailProduct(true);
  };

  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner PageCommonCSS">
            <h2 className="mainTitle">Request For Rent </h2>
            <p className="subText">Request For Rent Equipment </p>
            <hr />
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible1
                            ? "bi-chevron-down"
                            : "bi-chevron-right"
                        }`}
                        onClick={toggleCardVisibility1}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">AF</span>
                    </Col>
                    <Col xs={8} md={9} lg={9}>
                      <span className="headerTitle">Advanced Filter</span>
                      <span className="subHeaderTitle">Advanced Filter</span>
                    </Col>
                  </Row>
                </h2>

                <div
                  className={`accordion-collapse collapse show ${
                    isCardVisible1 ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    <Row className="pt-2 pb-4 d-flex align-items-center">
                      <Col
                        xs={12}
                        md={3}
                        lg={3}
                        className="commTopButtonRightLeftPadding mt-4"
                      >
                        <SearchField
                          name="searchKey"
                          // value={getCommonSearchTxt}
                          // onChange={(event) =>
                          //   setCommonSearchTxt(event.target.value)
                          // }
                          // onClick={() => handleSearchFuncApi()}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={3}
                        lg={3}
                        className="commTopButtonRightLeftPadding"
                      >
                        <ComboboxField
                          label="Equipments"
                          placeholder="Please select the Category"
                          data={CategorydropdownOptions}
                          id="category"
                          iconClassName="dropdownIcon"
                          name="category"
                          code="categorycode"
                          description="countryDesc"
                          setValue={selectedCategory?.category}
                          getvalue={setDropdownData}
                        />
                      </Col>

                      <Col
                        xs={12}
                        md={3}
                        lg={3}
                        className="commTopButtonRightLeftPadding"
                      >
                        <ComboboxField
                          label="Sort by"
                          placeholder="Please select the Category"
                          data={CategorydropdownOptions}
                          id="sortBy"
                          iconClassName="dropdownIcon"
                          name="sortBy"
                          code="sortBycode"
                          description="countryDesc"
                          setValue={selectedCategory.sortBy}
                          getvalue={setDropdownData}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={3}
                        lg={3}
                        className="commTopButtonRightLeftPadding"
                      >
                        <ComboboxField
                          label="Sub Category"
                          placeholder="Please select the Category"
                          data={Subcategory}
                          id="subCategory"
                          iconClassName="dropdownIcon"
                          name="subCategory"
                          code="subCategoryCode"
                          description="subCategoryDesc"
                          setValue={selectedCategory.subCategory}
                          getvalue={setDropdownData}
                        />
                      </Col>

                      <Col
                        xs={12}
                        md={3}
                        lg={3}
                        className="commTopButtonRightLeftPadding"
                      >
                        <ComboboxField
                          label="Price"
                          placeholder="Please select the Category"
                          data={pricedropdownOptions}
                          id="price"
                          iconClassName="dropdownIcon"
                          name="price"
                          code="pricecode"
                          description="priceDesc"
                          setValue={selectedCategory?.price}
                          getvalue={setDropdownData}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={{ span: 2, offset: 8 }}
                        lg={{ span: 2, offset: 8 }}
                        className="commTopButtonRightLeftPadding"
                      >
                        <button
                          className="btnTable"
                          onClick={handleSearchClick}
                        >
                          Search
                        </button>
                      </Col>
                      <Col
                        xs={12}
                        md={2}
                        lg={2}
                        className="commTopButtonRightLeftPadding"
                      >
                        <button className="btnTable" onClick={handleRefresh}>
                          Referesh
                        </button>
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
            <div className="accordion" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible2
                            ? "bi-chevron-down"
                            : "bi-chevron-right"
                        }`}
                        onClick={toggleCardVisibility2}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">P</span>
                    </Col>
                    <Col xs={6} md={4} lg={4}>
                      <span className="headerTitle">Equipment</span>
                      <span className="subHeaderTitle">Equipment</span>
                    </Col>

                    <Col xs={12} md={8} lg={8} className="headerButtonAlign">
                      <Col xs={3} md={3} lg={3} className="">
                        <button
                          className="btnTable d-flex justify-content-center"
                          onClick={requestForRent}
                        >
                          <p className="m-0 me-2">Request For Rent</p>
                          <i class="bi bi-plus-square"></i>
                        </button>
                      </Col>
                      <Col xs={3} md={3} lg={3} className="">
                        <button
                          className="btnTable"
                          onClick={cancelModalShow}
                          disabled={getSelectedRows.length > 0 ? false : true}
                        >
                          <i className="bi bi-x-circle"></i> Rent Cancel
                        </button>
                      </Col>
                      <Col xs={3} md={3} lg={3} className="">
                        <button
                          className="btnTable d-flex justify-content-center"
                          onClick={cancelModalShow}
                          disabled={getSelectedRows.length > 0 ? false : true}
                        >
                          <p className="m-0 me-2">Rent Hold</p>
                          <i class="bi bi-plus-square"></i>
                        </button>
                      </Col>
                    </Col>
                  </Row>
                </h2>
                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${
                    isCardVisible2 ? "visible" : ""
                  }`}
                  // aria-labelledby="headingOne"
                  // data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <DataTable
                          title=""
                          columns={columns}
                          // data={data}
                          data={
                            filteredProducts.length > 0
                              ? filteredProducts
                              : data
                          }
                          // progressPending={purchaseOrderData?.status}
                          paginationRowsPerPageOptions={
                            CustomerConstants.ROW_PER_PAGE
                          }
                          pagination
                          paginationServer
                          paginationTotalRows={purchaseOrderTable.total}
                          //   onChangeRowsPerPage={handlePerRowsChange}
                          //   onChangePage={handlePageChange}
                          onSelectedRowsChange={handleRowSelected}
                          selectableRows
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>
      <RequestRentListEditModal
        show={modalShowEditProduct}
        onHide={() => hideModal()}
        equipmentData={editEquipmentData}

        // dropdownData={getAccountGroup}
      />
      <EquipmentModal
        show={modalShowAddProduct}
        onHide={() => hideModal()}
        // selectedData={getSelectedRows}
      />
      <RequestForRentDetails
        show={modalShowDetailProduct}
        onHide={() => hideModal()}
        equipmentData={equipmentData}
      />
      <EquipmentModalCopy
        show={modalShowForRent23}
        onHide={() => hideModal()}
        selectedData={getSelectedRows}
      />
      <RentCancelModal
        title="Equipment Rent Request"
        // type={"PR"}
        show={getCancelModalStatus}
        onHide={cancelModalHide}
        selectedrow={getSelectedRows}
      />
    </main>
  );
};

export default RequestForRentList;
